<div class="container-fluid main-card">
    <div class="row">
        <div class="col-sm-8 col-11">
            <h1>
                {{ (this.currentSearch && idSearch != 'result' ? 'Votre recherche ' + this.currentSearch.title : 'Moteur de recherche') }}
                <span>Trouvez les annonces rentables de votre secteur</span>
            </h1>
        </div>
        <div class="col-sm-4 col-1">
            <p class="btn btn-outline float-right  mobile-icon mt-4" (click)="openTuto()">
                <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : Moteur de recherche</span>
            </p>
        </div>
    </div>
    <div class="row mb-2 mb-sm-4">
        <div class="col-lg-3 col-sm-12 col-6 pe-0">
            <mat-form-field class="no-label"
                            [stepContent]="searchSaveListContent"
                            [joyrideStep]="'searchSaveListStep'"
                            (prev)="saveSearch()"
            >
                <mat-label>Séléctionner une recherche enregistrée</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="currentSearch"
                            (ngModelChange)="trackingService.click('search_result_select_search', currentSearch.id);loadSearch($event)"
                            [disabled]="userSearchs.length == 0 || !authenticationService.isAllowed('essentiel')"
                            class="select-search" placeholder="Mes recherches">
                    <mat-option *ngFor="let s of userSearchs" [value]="s">{{s.title}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-3 col-3 ps-2 dropdown dropstart hide-mobile">
            <button
                *ngIf="currentSearch && idSearch != 'result'"
                (click)="trackingService.click('search_result_search_edit', currentSearch.id)"
                class="btn btn-outline mobile-icon" id="dropdownEdit" data-bs-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <div id="editDropdown" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownEdit"
                 aria-haspopup="true"
                 aria-expanded="false">
                <ul class="pictoList">
                    <li>
                        <a (click)="trackingService.click('search_result_search_rename', currentSearch.id);editSearch()">
                            <i class="fa cfa cfa-pencil"></i>
                            Renommer
                        </a>
                    </li>
                    <li>
                        <a (click)="trackingService.click('search_result_search_duplicate', currentSearch.id);duplicateSearch()">
                            <i class="fa cfa cfa-clone"></i>
                            Dupliquer
                        </a>
                    </li>
                    <li class="delete">
                        <a (click)="trackingService.click('search_result_search_delete', currentSearch.id);deleteSearch()">
                            <i class="fa cfa cfa-trash"></i>
                            Supprimer
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-lg-6 col-sm-12 col-6 text-end ps-0">
            <div class="d-inline-block" [stepContent]="searchSave2Content" [joyrideStep]="'searchSave2Step'">
                <button class="btn btn-outline mobile-icon"
                        (click)="trackingService.click('search_result_search_save', currentSearch.id);saveSearch()"
                        *ngIf="this.currentSearch && idSearch == 'result'"
                        (next)="saveSearch()"
                        [stepContent]="searchSaveContent"
                        [joyrideStep]="'searchSaveStep'">
                    <i class="fa cfa cfa-save"></i>
                    <span>Sauvegarder la recherche</span>
                </button>
            </div>

            <button
                *ngIf="currentSearch && idSearch != 'result'"
                (click)="trackingService.click('search_result_search_edit', currentSearch.id)"
                class="btn me-2 btn-outline mobile-icon visible-mobile" id="dropdownEdit_m" data-bs-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>

            <button
                *ngIf="this.currentSearch && idSearch != 'result'"
                class="btn btn-outline mobile-icon"
                (click)="trackingService.click('search_result_save_alert', currentSearch.id);saveAlerte()"
                [stepContent]="alertCreateStepContent"
                [joyrideStep]="'alertCreateStep'"
                (next)="saveAlerte()">
                <i class="fa fa-bell-o"></i>
                <span *ngIf="this.currentSearch.frequency_alert == '0'">Créer une alerte</span>
                <span *ngIf="this.currentSearch.frequency_alert != '0'">Gérer mon alerte</span>
            </button>

            <a class="btn btn-primary ms-2 ps-sm-4 pe-sm-4 mobile-icon"
               routerLink="/app/search/{{idSearch}}/filters"
               [stepContent]="searchResultFilterContent"
               [joyrideStep]="'searchResultFilterStep'">
                <i class="fa cfa cfa-filter"></i>
                <span>Filtrer</span>
            </a>

            <div id="editDropdown_m" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownEdit_m"
                 aria-haspopup="true"
                 aria-expanded="false">
                <ul class="pictoList">
                    <li>
                        <a (click)="trackingService.click('search_result_search_rename', currentSearch.id);editSearch()">
                            <i class="fa cfa cfa-pencil"></i>
                            Renommer
                        </a>
                    </li>
                    <li>
                        <a (click)="trackingService.click('search_result_search_duplicate', currentSearch.id);duplicateSearch()">
                            <i class="fa cfa cfa-clone"></i>
                            Dupliquer
                        </a>
                    </li>
                    <li class="delete">
                        <a (click)="trackingService.click('search_result_search_delete', currentSearch.id);deleteSearch()">
                            <i class="fa cfa cfa-trash"></i>
                            Supprimer
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row mt-md-3 mb-md-3 resultRow">
        <div class="col-md-6 col-12">
            <h2 *ngIf="nb_result >= 0">
                <b class="text-primary"><span *ngIf="nb_result == 10000">Plus de&nbsp;</span>{{ nb_result | number }}</b>&nbsp;
                <ng-container *ngIf="nb_result <= 1">annonces trouvée</ng-container>
                <ng-container *ngIf="nb_result > 1">annonces trouvées</ng-container>
            </h2>
        </div>
        <div class="col-md-3 col-3 pe-2">
            <button class="btn btn-outline float-right mobile-icon btn-indicateurs"
                    (click)="trackingService.click('search_result_indicateur', currentSearch.id ? currentSearch.id : 'result');displayColumsSelection()">
                <i class="fa cfa cfa-sliders"></i>
                <span>Indicateurs</span>
            </button>
        </div>
        <div class="col-md-3 col-9 ps-0">
            <mat-form-field class="no-label">
                <mat-label>Trier par :</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="sort"
                            (ngModelChange)="trackingService.click('search_result_sort', sort);setSort();"
                            placeholder="Trier par">
                    <mat-option [value]="'first_publication-desc'">Trier par : Date (Décroissant)</mat-option>
                    <mat-option [value]="'first_publication-asc'">Trier par : Date (Croissant)</mat-option>
                    <mat-option [value]="'price-desc'">Trier par : Prix (Décroissant)</mat-option>
                    <mat-option [value]="'price-asc'">Trier par : Prix (Croissant)</mat-option>
                    <mat-option [value]="'square_price-desc'">Trier par : Prix au m² (Décroissant)</mat-option>
                    <mat-option [value]="'square_price-asc'">Trier par : Prix au m² (Croissant)</mat-option>
                    <mat-option [value]="'square_price_diff-desc'">Trier par : Diff de prix au m² (Décroissant)</mat-option>
                    <mat-option [value]="'square_price_diff-asc'">Trier par : Diff de prix au m² (Croissant)</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-4" [hidden]="!columsSelection">
            <div class="card searchResult selectColumns">
                <h3>
                    <i (click)="trackingService.click('search_result_indicateur_close', currentSearch.id ? currentSearch.id : 'result');displayColumsSelection()"
                       class="fa fa-close float-right cursor-pointer"></i>
                    Personnalisation des indicateurs
                </h3>
                <p>Vous pouvez choisir les indicateurs qui seront affichés lors de votre recherche. </p>
                <mat-button-toggle-group class="container-fluid" [multiple]="true" #group="matButtonToggleGroup"
                                         [value]="displayedColumns" (change)="onColChange(group.value)">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <b class="fs-4 mb-2">Informations générales</b>

                                <mat-button-toggle value="ad.square_land">
                                    Suface du terrain
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="lots.length">
                                    Nombre de lots
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad.owner_name">
                                    Nom du contact
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="dpe">
                                    DPE
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ges">
                                    GES
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="liens">
                                    Liens de l'annonce
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_rent">
                                    Total des loyers
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="charge">
                                    Total des charges
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_property_tax">
                                    Taxe foncière
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="amount_copro">
                                    Charges de copropriété
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="monthly">
                                    Mensualité
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="status">
                                    Status du projet
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>
                            </div>
                            <div class="col-md-6">
                                <b class="fs-4 mb-2">Informations sur la ville</b>

                                <mat-button-toggle value="ad_city.price_diff">
                                    Différence de prix
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.advice_price">
                                    Prix au m²
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.demographie_annuelle">
                                    Population
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="favorite.ad_city.renta">
                                    Rentabilité moyenne
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.mv">
                                    Niveau de vie moy par hab
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tv">
                                    Taux de logements vacants
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.te">
                                    Taux d'étudiants
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tc">
                                    Taux de chômage
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.carac_commune.tl">
                                    Taux de locataires
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                                <mat-button-toggle value="ad_city.logement.anc_loc_ann">
                                    Ancienneté des locataires
                                    <span class="check"><i class="fa fa-check"></i></span>
                                </mat-button-toggle>

                            </div>
                        </div>
                        <div class="row">
                            <button class="btn btn-primary center" (click)="trackingService.click('search_result_indicateur_valider', currentSearch.id ? currentSearch.id : 'result');displayColumsSelection()">
                                Valider
                            </button>
                        </div>
                    </div>
                </mat-button-toggle-group>
            </div>
        </div>

        <ng-container *ngFor="let favorite of favorites; index as i;">
            <div class="col-12 mb-4" id="ad_{{favorite.ad.ai_id}}">
                <div class="card searchResult {{ favorite.hide == true ? 'hidden' : '' }}" [hidden]="favorite.ad.real_estate_type == '' && favorite.ad.square == 0 ||
                (currentSearch.search_ad_params.hide_view == true && favorite.favorite_list.id == '' && favorite.id != '')"
                     [stepContent]="searchResultContent"
                     [joyrideStep]="'searchResultStep' + i">
                    <div
                        class="card-body card-{{ favorite.ad.ai_id }} {{ favorite.favorite_list.id == '' && favorite.id != '' ? 'already_open' : '' }}">
                        <div class="container-fluid">
                            <div class="mainRow row">
                                <div class="wrapImg me-2 mb-lg-0 mb-2">
                                    <div *ngIf="isNew(favorite)" class="new">
                                        Nouveau
                                    </div>
                                    <img *ngIf="favorite.pictures.length == 0" src="assets/no-photo.png" alt=""/>
<!--                                    <img class="zoom" *ngIf="favorite.pictures.length > 0" src="{{favorite.pictures[0]}}" (click)="trackingService.click('search_result_preview_open', favorite.ad.ai_id);previewAd(favorite, 0)" alt=""/>-->
                                    <div *ngIf="favorite.pictures.length > 0" id="picturesCarousel{{favorite.ad.ai_id}}"
                                         class="carousel slide" data-ride="carousel">
                                        <div class="carousel-inner"
                                             (click)="trackingService.click('search_result_preview_open', favorite.ad.ai_id);previewAd(favorite, i)">
                                            <div *ngFor="let picture of favorite.pictures; index as ig;"
                                                 [ngClass]="{'carousel-item': true, 'active': ig == 0}"
                                                 [ngStyle]="{ 'background-image': 'url(' + picture + ')'}">
                                                <img *ngIf="picture" style="display: none;" src="{{ picture }}"
                                                     (error)="changeImg($event, ig, favorite.ad.ai_id)">
                                            </div>
                                        </div>
                                        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-prev"
                                                type="button"
                                                [attr.data-bs-target]="'#picturesCarousel' + favorite.ad.ai_id"
                                                data-bs-slide="prev">
                                            <i class="fa fa-chevron-left"
                                               (click)="trackingService.click('search_result_image_prev', favorite.ad.ai_id);"></i>
                                            <span class="visually-hidden">Previous</span>
                                        </button>
                                        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-next"
                                                type="button"
                                                [attr.data-bs-target]="'#picturesCarousel' + favorite.ad.ai_id"
                                                data-bs-slide="next">
                                            <i class="fa fa-chevron-right"
                                               (click)="trackingService.click('search_result_image_next', favorite.ad.ai_id);"></i>
                                            <span class="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="mainInfo me-lg-2 mb-lg-0 mb-2"
                                     [stepContent]="searchResultMainInfoContent"
                                     [joyrideStep]="'searchResultMainInfoStep' + i">
                                    <b class="price text-primary fs-2 price">
                                        {{ favorite.ad.price | number: '1.0-0' }} €
                                    </b>
                                    <b class="squarePrice text-secondary d-block">
                                        {{ (favorite.ad.price / favorite.ad.square) | number: '1.0-0' }} €/m²
                                    </b>
                                    <b class="estateType mt-2 fs-4 d-block">
                                        {{ favorite.ad.real_estate_type }}
                                    </b>

                                    <b class="squareRoom text-secondary d-block">
                                        <ng-container *ngIf="favorite.ad.square > 0">
                                            <span class="visible-mobile">&nbsp;</span>{{ favorite.ad.square | number: '1.0-0' }} m²
                                        </ng-container>
                                        <ng-container *ngIf="favorite.ad.square > 0 && favorite.ad.rooms > 0">
                                            -
                                        </ng-container>
                                        <ng-container *ngIf="favorite.ad.rooms > 0">
                                            {{ favorite.ad.rooms }} pièces
                                        </ng-container>
                                    </b>

                                    <span class="fpb text-secondary d-block mt-2 fs-small">
                                        <i class="fa cfa cfa-calendar"></i> {{ favorite.ad.first_publication_date }}
                                    </span>

                                    <a class="mt-2 btn btn-primary btn-sm d-block"
                                       *ngIf="!favorite.isAdVisible"
                                       (click)="trackingService.click('search_result_secret_link', favorite.ad.ai_id);">
                                        Lien secret 🤫
                                    </a>

                                    <p *ngIf="favorite.isAdVisible && !favorite.loading" class="mb-0">
                                        <a *ngIf="favorite.id === '' && favorite.favorite_list.id === ''" class="mt-2 btn btn-primary btn-sm d-block"
                                           [routerLink]="['/app/favorites/open', favorite.ad.ai_id]"
                                           [queryParams]="{returnUrl: url}"
                                           (click)="trackingService.click('search_result_open_ad', favorite.ad.ai_id);"
                                           [stepContent]="searchResultOpenContent"
                                           [joyrideStep]="'searchResultOpenStep' + i">
                                            Ouvrir l'analyse
                                        </a>
                                        <a *ngIf="favorite.id !== '' && favorite.favorite_list.id === ''" class="mt-2 btn btn-primary btn-sm d-block"
                                           [routerLink]="['/app/annonces', favorite.id, 'annonce']"
                                           [queryParams]="{returnUrl: url}"
                                           (click)="trackingService.click('search_result_open_ad', favorite.ad.ai_id);"
                                           [stepContent]="searchResultOpenContent"
                                           [joyrideStep]="'searchResultOpenStep' + i">
                                            Ouvrir l'analyse
                                        </a>
                                        <a *ngIf="favorite.favorite_list.id !== ''" class="mt-2 btn btn-primary btn-sm d-block"
                                           [routerLink]="['/app/favorites/', favorite.favorite_list.id, favorite.id, 'annonce']"
                                           (click)="trackingService.click('search_result_open_ad', favorite.ad.ai_id);"
                                           [stepContent]="searchResultOpenContent"
                                           [joyrideStep]="'searchResultOpenStep' + i">
                                            Ouvrir le favoris
                                        </a>
                                    </p>
                                    <p *ngIf="favorite.isAdVisible && favorite.ad.urls.length > 0 && favorite.ad.urls[0].provider != '' && favorite.loading">
                                        <mat-spinner class="mt-3" diameter="24" color="second"></mat-spinner>
                                    </p>
                                    <a class="mt-2 btn btn-outline btn-sm d-block"
                                       *ngIf="favorite.ad.urls.length == 0 && favorite.isAdVisible">
                                        Plus en ligne
                                    </a>
                                </div>
                                <div class="kpiInfo pe-3 ps-3 col-xxl-6 col-xl-6 col-lg-5"
                                     [stepContent]="searchResultInfoContent"
                                     [joyrideStep]="'searchResultInfoStep' + i">
                                    <div class="row" *ngIf="favorite.isAdVisible">
                                        <div class="col-12 iconeInfo">
                                            <div class="icone float-right bg-white add-ad"
                                                 *ngIf="favorite.favorite_list.id == '' && !favorite.loading">
                                                <i matTooltip="Ajouter à la liste de favoris"
                                                   (click)="trackingService.click('search_result_add_fav', favorite.ad.ai_id);saveFav(favorite)"
                                                   class="fa fa-heart-o" type="button"></i>
                                            </div>
                                            <div class="icone float-right add-ad"
                                                 *ngIf="favorite.favorite_list.id != '' && !favorite.loading">
                                                <i matTooltip="Supprimer mon favoris"
                                                   (click)="trackingService.click('search_result_delete_fav', favorite.ad.ai_id);deleteFav(favorite)"
                                                   class="fa fa-heart text-red" type="button"></i>
                                            </div>
                                            <div class="icone float-right loading-icone" *ngIf="favorite.loading">
                                                <mat-spinner diameter="30" color="second"></mat-spinner>
                                            </div>
                                            <div class="icone float-right bg-white hide-listing">
                                                <i matTooltip="Masquer cette annonce"
                                                   (click)="trackingService.click('search_result_hide_fav', favorite.ad.ai_id);hideFav(favorite)"
                                                   class="fa fa-eye-slash" type="button"></i>
                                            </div>
                                            <div class="icone float-right bg-white add-bug">
                                                <i matTooltip="Signaler une erreur ou un bug sur cette annonce"
                                                   (click)="trackingService.click('search_result_bug_open', favorite.ad.ai_id);addBug(favorite)"
                                                   class="fa fa-bug" type="button"></i>
                                            </div>
                                            <div class="icone"
                                                 *ngIf="favorite.favorite_list.id == ''  && favorite.id != ''">
                                                <i matTooltip="Annonce déjà ouverte"
                                                   class="fa fa-eye text-grey ad_category" type="button"></i>
                                            </div>
                                            <div class="icone"
                                                 *ngIf="favorite.comment != ''  && favorite.id != ''">
                                                <p matTooltip="{{ favorite.comment }}"
                                                   (click)="trackingService.click('search_result_favorite_notes_ico', favorite.id);noteFavorite(favorite)"
                                                   class="svg notes" matTooltip="Baisse de prix"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.price_change">
                                                <p class="svg baisse-prix" matTooltip="Baisse de prix"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.work">
                                                <p matTooltip="Travaux à prévoir" class="svg work"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.rent">
                                                <p class="svg rent-result" matTooltip="Locataire en place"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.adress != '' && favorite.ad.adress != '-'">
                                                <p class="svg adress" matTooltip="Adresse du bien enregistrée : {{favorite.ad.adress}}"></p>
                                            </div>
                                            <div class="icone" *ngIf="(favorite.ad.adress == '' || favorite.ad.adress == '-') && favorite.ad.iris.length > 5 && favorite.ad.iris !=  favorite.ad.city.city_code + '0000'">
                                                <p class="svg iris" matTooltip="Quartier du bien enregistrée : {{ favorite.quartierLib }}"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.bad_location">
                                                <p class="svg bad_city"
                                                   matTooltip="La ville renseignée semble incorrecte"></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.category == 'Viager'">
                                                <p class="svg viager" matTooltip="Le bien est vendu en viager."></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.category == 'Enchere'">
                                                <p class="svg enchere" matTooltip="Le bien est vendu aux enchères."></p>
                                            </div>
                                            <div class="icone" *ngIf="favorite.ad.has_local_commercial">
                                                <p class="svg commerce" matTooltip="Le lot comprend un local commercial"></p>
                                            </div>
                                            <div class="icone" *ngIf="!favorite.isSquareValid">
                                                <p class="svg bad_square" matTooltip="La surface du bien semble incorrect"></p>
                                            </div>
                                        </div>
                                        <div class="col-12 fs-small city">
                                            <i class="cfa cfa-pin"></i>
                                            <span class="text-primary me-3" *ngIf="favorite.ad_city.name != ''">
                                                {{ favorite.ad_city.name }} ({{ favorite.ad_city.zip_code }})
                                            </span>
                                            <span class="text-primary me-3" *ngIf="favorite.ad_city.name == ''">
                                                Aucune ville renseigné
                                            </span>
                                            <span class="hide-mobile">
                                                <ng-container *ngIf="favorite.ad.urls.length > 0">
                                                    <i class="fa fa-flag me-2"></i>
                                                    {{ favorite.providerLib }}
                                                </ng-container>
                                                <ng-container *ngIf="favorite.ad.urls.length > 1">
                                                    +{{ favorite.ad.urls.length - 1 }} autres
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div class="col-12 dataInfo mt-1 mt-sm-4"
                                             (click)="trackingService.click('search_result_open_ad_dataInfo', favorite.ad.ai_id);">
                                            <div class="row">
                                                <ng-container *ngFor="let dc of displayedColumns | slice:0:max_display; index as idc;">
                                                    <div class="kpi-value kpi-blank"
                                                         *ngIf="idc == 4 && (displayedColumns.length == 7 || displayedColumns.length == 8)"></div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.price_diff'">
                                                        <label>Différence
                                                            <i class="fa fa-question-circle"
                                                               matTooltip="Comparaison avec {{ favorite.fullPriceLib }}"></i>
                                                        </label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.price / favorite.square < favorite.advice_price, 'text-red' : favorite.price / favorite.square > favorite.advice_price}">
                                                            <ng-container *ngIf="favorite.advice_price > 0">
                                                                {{ ((favorite.price / favorite.square) / favorite.advice_price * 100) - 100 | number:'1.0-0' }}
                                                                %
                                                            </ng-container>
                                                            <ng-container *ngIf="favorite.advice_price == 0">-
                                                            </ng-container>
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.demographie_annuelle'">
                                                        <label>Nb. d'habitants</label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.ad_city.demographie_annuelle.Cr == 1, 'text-red' : favorite.ad_city.demographie_annuelle.Cr == -1}">
                                                            {{ favorite.ad_city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] | number: '1.0-0' }}
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == 1"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie en hausse"
                                                               class="fa fa-arrow-up"></i>
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == 0"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie stable"
                                                               class="fa fa-arrow-right"></i>
                                                            <i *ngIf="favorite.ad_city.demographie_annuelle.Cr == -1"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Démographie en baisse"
                                                               class="fa fa-arrow-down"></i>
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.mv'">
                                                        <label>Niv. de vie/hab</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.carac_commune.MED_NV | number: '1.0-0' }} €
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'favorite.ad_city.renta'">
                                                        <label>Rend. ville
                                                            <i class="fa fa-question-circle"
                                                               matTooltipClass="tooltip-button"
                                                               matTooltip="Rendement moyen dans la ville (tous types de biens confondus et sans prise en compte des travaux)."></i>
                                                        </label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.renta["R"] * 100| number: '1.0-1' }} %
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.te'">
                                                        <label>Étudiants</label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.ad_city.carac_commune.T_etud >= 0.12 , 'text-red' : favorite.ad_city.carac_commune.T_etud <= 0.08}">
                                                            {{ favorite.ad_city.carac_commune.T_etud * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.advice_price'">
                                                        <label>Prix au m²
                                                            <i class="fa fa-question-circle"
                                                               matTooltip="Moyenne pour {{ favorite.fullPriceLib }}"></i>
                                                        </label>
                                                        <p class="value">
                                                        <span
                                                            *ngIf="favorite.advice_price != 0">{{ favorite.advice_price | number:'1.0-0'  }}</span>
                                                            <span *ngIf="favorite.advice_price == 0">-</span> €/m²
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'amount_rent'">
                                                        <label>Loyer HC conseillé</label>
                                                        <p class="value">
                                                            {{ favorite.amount_rent | number: '1.0-0' }}  €/mois
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tc'">
                                                        <label>Chômage</label>
                                                        <p [ngClass]="{'value': true, 'text-green' : favorite.ad_city.carac_commune.T_chom < 0.075 , 'text-red' : favorite.ad_city.carac_commune.T_chom >= 0.13}">
                                                            {{ favorite.ad_city.carac_commune.T_chom * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad.square_land'">
                                                        <label>Surface terrain</label>
                                                        <p class="value">
                                                            {{ favorite.ad.square_land }} m²
                                                        </p>
                                                    </div>
                                                    <div class="kpi-value" *ngIf="dc == 'lots.length'">
                                                        <label>Nombre de lots</label>
                                                        <p class="value">
                                                            {{ favorite.nb_lots }}
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad.owner_name'">
                                                        <label>Contact</label>
                                                        <p class="value text">
                                                            {{ favorite.ad.owner_name | slice:0:15 }}
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'dpe'">
                                                        <label>DPE</label>
                                                        <app-dpe [favorite]="favorite"></app-dpe>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ges'">
                                                        <label>GES</label>
                                                        <app-ges [favorite]="favorite"></app-ges>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'liens'">
                                                        <label>Liens</label>
                                                        <div class="value value-link" *ngIf="favorite.ad.urls">
                                                            <a [ngClass]="'btn btn-'+favorite.ad.urls[favorite.smallLink].provider+' btn-sm'"
                                                               *ngIf="favorite.ad.urls.length > 0 && favorite.providerLib != 'Site partenaire'"
                                                               href="{{ favorite.ad.urls[favorite.smallLink].url }}"
                                                               target="_blank">
                                                                {{ favorite.providerLib }}
                                                            </a>

                                                            <a [ngClass]="'btn btn-'+favorite.ad.urls[favorite.smallLink].provider+' btn-sm'"
                                                               *ngIf="favorite.ad.urls.length > 0 && favorite.providerLib == 'Site partenaire'">
                                                                Site partenaire
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <!-- Ville -->

                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tv'">
                                                        <label>Logements vacants</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.logement.T_LV * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.carac_commune.tl'">
                                                        <label>Taux de locataires</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.logement.T_LOC * 100 | number: '1.1-1' }}
                                                            %
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'ad_city.logement.anc_loc_ann'">
                                                        <label>Ancienneté des locataires</label>
                                                        <p class="value">
                                                            {{ favorite.ad_city.logement.anc_loc_ann | number: '1.1-1' }}
                                                            ans
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'charge'">
                                                        <label>Charges</label>
                                                        <p class="value">
                                                            {{ favorite.charge | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'amount_property_tax'">
                                                        <label>Taxe foncière</label>
                                                        <p class="value">
                                                            {{ favorite.amount_property_tax | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'amount_copro'">
                                                        <label>Charges de copro</label>
                                                        <p class="value">
                                                            {{ favorite.amount_copro | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value" *ngIf="dc == 'monthly'">
                                                        <label>Mensualité</label>
                                                        <p class="value">
                                                            {{ favorite.monthly | number: '1.0-0' }} €
                                                        </p>
                                                    </div>

                                                    <div class="kpi-value pe-0" *ngIf="dc == 'status'">
                                                        <label>Status</label>
                                                        <p *ngIf="favorite.favorite_list.id != ''">
                                                            <app-status [favorite]="favorite"></app-status>
                                                        </p>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="!favorite.isAdVisible">
                                        <b class="title text-center d-block mt-3"
                                           (click)="trackingService.click('search_result_premium', favorite.ad.ai_id);openLybox(favorite, i)">
                                            Cette annonce est reservée à nos membres premium<br/>
                                            <button
                                                class="btn btn-info mt-3 mb-3">
                                                Passer premium
                                            </button>
                                        </b>
                                        <b class="text-center d-block mb-1"><i class="fa fa-info-circle me-2"></i> Le
                                            saviez vous ?</b>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow > 60 && favorite.ad_id % 6 == 0">
                                            En investissant dans ce bien, votre abonnement LyBox sera
                                            rentabilisé en
                                            1 semaine !
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow > 60 && favorite.ad_id % 6 == 1">
                                            Utiliser LyBox, c’est récupérer du temps pour visiter des biens,
                                            faire
                                            des offres d’achat, ou bien prendre du temps libre avec sa famille
                                            et
                                            ses amis.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow > 60 && favorite.ad_id % 6 == 2">
                                            LyBox permet de générer un dossier bancaire professionnel pour être
                                            sûr
                                            d’obtenir votre crédit immobilier.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow > 60 && favorite.ad_id % 6 == 3">
                                            Il y a environ 35 000 communes en France, que vous pouvez analyser
                                            avec
                                            LyBox.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow > 60 && favorite.ad_id % 6 == 4">
                                            Des milliers d’investisseurs ont réussi leur premier investissement
                                            avec
                                            LyBox.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow > 60 && favorite.ad_id % 6 == 5">
                                            Déjà plus de 100 investisseurs s’intéressent à ce bien. Ne le
                                            laissez
                                            pas passer !
                                        </p>

                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 0">
                                            Les investisseurs qui utilisent LyBox passent à l’action en moyenne
                                            3
                                            fois plus souvent que les autres investisseurs.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 1">
                                            L’abonnement LyBox est déductible de vos impôts sur vos revenus
                                            locatifs. En moyenne, c’est une économie de 47,2% sur le montant de
                                            l’abonnement.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 2">
                                            Les portails généralistes comme Leboncoin ou Seloger ne proposent
                                            que
                                            80% des annonces immobilières disponibles sur le Net.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 3">
                                            Les investisseurs qui utilisent LyBox gagnent en moyenne 5h de
                                            recherche
                                            par semaine.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 4">
                                            Le meilleur moment pour investir dans l’immobilier, c’est
                                            maintenant.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 5">
                                            LyBox propose plus de 100 000 nouveaux biens immobiliers chaque
                                            semaine.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 6">
                                            Vous pouvez programmer des alertes mails sur vos recherches.
                                        </p>
                                        <p class="text-center"
                                           *ngIf="favorite.cash_flow <= 60 && favorite.ad_id % 8 == 7">
                                            LyBox dispose d’un module pour vous aider à trouver les villes
                                            rentables
                                            autour de chez vous.
                                        </p>
                                    </div>
                                    <button *ngIf="favorite.hide == true" class="showHide btn btn-outline"
                                            (click)="trackingService.click('search_result_show_fav', favorite.ad.ai_id);hideFav(favorite)">
                                        <i class="fa fa-eye"></i> Afficher l’annonce
                                    </button>
                                </div>
                                <div class="lastInfo"
                                     [stepContent]="searchResultKpiContent"
                                     [joyrideStep]="'searchResultKpiStep' + i">
                                    <div class="wrap p-3">
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block hide-mobile">Cash flow / mois</label>
                                            <label class="fs-small d-block desktop">Cash flow</label>
                                            <b class="text-primary fs-4">
                                            <span
                                                *ngIf="favorite.amount_rent != 0">{{ favorite.cash_flow  | number: '1.0-0' }}</span>
                                                <span *ngIf="favorite.amount_rent == 0">- </span> €
                                            </b>
                                        </div>
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Rendement brut</label>
                                            <b class="text-primary fs-4">
                                            <span
                                                *ngIf="favorite.efficiency_brut != 0">{{ favorite.efficiency_brut  | number: '1.1-1' }}</span>
                                                <span *ngIf="favorite.efficiency_brut == 0">- </span> %
                                            </b>
                                        </div>
                                        <div class="col-4 col-lg-12 mb-lg-3">
                                            <label class="fs-small d-block">Rendement net</label>
                                            <b class="text-primary fs-4">
                                            <span
                                                *ngIf="favorite.efficiency_net != 0">{{ favorite.efficiency_net  | number: '1.1-1' }}</span>
                                                <span *ngIf="favorite.efficiency_net == 0">- </span> %
                                            </b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="col-12 mb-4" [hidden]="nb_result != 0 || loading == true || page != 1">
            <div class="card searchResult">
                <div>
                    <b class="title text-center d-block mt-3 fs-3 mb-3">
                        Aucun résultat ne correspond à votre recherche.<br/>
                    </b>
                    <p class="text-center">
                        Modifier vos filtres pour faire apparaître des résultats.<br/>
                        <a class="btn btn-info mt-4 mb-3"
                           routerLink="/app/search/{{idSearch}}/filters">
                            <span>Modifier les filtres</span>
                        </a>
                    </p>
                </div>
            </div>
        </div>

        <div class="col-12 mb-4" [hidden]="loading == true || page < pages[pages.length-1] || nb_result == 0">
            <div class="card searchResult">
                <div>
                    <b class="title text-center d-block mt-3 fs-3 mb-3">
                        Aucun autre résultat de disponible pour votre recherche.<br/>
                    </b>
                    <p class="text-center"
                       *ngIf="this.currentSearch && idSearch != 'result' && this.currentSearch.frequency_alert == '0'">
                        Une alerte permet de recevoir en temps réel des mails sur les nouvelles annonces qui
                        correspondent à vos filtres.<br/>
                        <button class="btn btn-info mt-4 mb-3"
                                (click)="trackingService.click('search_result_save_alert_no_more_result', currentSearch.id);saveAlerte()"
                                [stepContent]="alertCreateStepContent"
                                [joyrideStep]="'alertCreateStep'"
                                (next)="saveAlerte()">
                            <i class="fa fa-bell-o"></i>
                            Créer une alerte
                        </button>
                    </p>

                    <p class="text-center" *ngIf="this.currentSearch && idSearch == 'result'">
                        Une recherche enregistrée permet de recevoir en temps réel des alertes mails sur les nouvelles
                        annonces<br/>
                        <button class="btn btn-info mt-4 mb-3 mobile-icon"
                                (click)="trackingService.click('search_result_search_save_no_more_result', currentSearch.id);saveSearch()">
                            <i class="fa cfa cfa-save"></i>
                            <span>Sauvegarder la recherche</span>
                        </button>
                    </p>
                </div>
            </div>
        </div>

        <div class="col-12" [hidden]="!loading">
            <div class="card card-loading">
                <div class="card-body">
                    <mat-spinner color="second"></mat-spinner>
                </div>
            </div>
        </div>

        <div class="col-12 mb-4"
             *ngIf="favorites.length > 0 && loading == false && !this.authenticationService.isAllowed('essentiel')">
            <div class="card searchResult">
                <div>
                    <b class="title text-center d-block mt-3 fs-3 mb-3">
                        Débloquer toutes les fonctionnalités du moteur de recheche.<br/>
                    </b>
                    <p class="text-center">
                        Rechercher sur plus de 700 sites immobiliers en même temps.<br/>
                        Le moteur de recherche est disponible à partir du forfait “Essentiel”.<br/>
                        <a class="btn btn-info mt-4 mb-3"
                           [routerLink]="['/app/user/plan']"
                           (click)="trackingService.click('search_result_more_result_unlock', currentSearch.id);saveAlerte()"
                        >
                            Débloquer cette fonctionnalité
                        </a>
                    </p>
                </div>
            </div>
        </div>

        <ul class="pagination mb-4" *ngIf="loading == false">
            <li *ngIf="page > 1"><a class="prev" [routerLink]="['/app/search', idSearch]" [queryParams]="{page: page - 1}"><</a></li>
            <li *ngFor="let p of pages"><a [routerLink]="['/app/search', idSearch]" [queryParams]="{page: p}" [ngClass]="{'current' : p == page}">{{ p }}</a></li>
            <li *ngIf="page < pages[pages.length-1]"><a class="next" [routerLink]="['/app/search', idSearch]" [queryParams]="{page: page + 1}">></a></li>
        </ul>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="searchStepContent"
             joyrideStep="searchStep"
             stepPosition="center">
</joyrideStep>
<ng-template #searchStepContent>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/search-1.png" class="user_onboarding_visuel"/>
    <div class="p-2 user_onboarding_content">
        <h2>Comment trouver des biens rentables ?</h2>
        <p>
            Chez LyBox, nous avons développé <b>un moteur de recherche sur mesure</b> pour l’investissement immobilier.
        </p>
        <ul>
            <li>Réunis <b>toutes les annonces</b> de plus de 700 sites immobiliers</li>
            <li>Utilise des filtres de recherche <b>spécial investissement</b></li>
        </ul>
        <p>
            Prêt à trouver <b>votre prochaine pépite ?</b> C’est parti !
        </p>
    </div>
</ng-template>
<joyrideStep [stepContent]="searchInfoContent"
             joyrideStep="searchInfoStep"
             stepPosition="center">
</joyrideStep>
<ng-template #searchInfoContent>
    <div class="user_onboarding_content">
        <h2>Aperçu des annonces</h2>
        <p>
            Les annonces provenant des <b>différents sites</b> apparaissent ici.<br/>
            <br/>
            Les <b>informations clés</b> sont visibles et vous permettent de savoir en quelques secondes si vous devez
            ouvrir
            l’annonce.<br/>
            <br/>
            La qualité des données est un enjeu majeur chez LyBox. C’est pourquoi nous n’utilisons que <b>des sources de
            données officielles</b> :<br/>
        </p>
        <ul>
            <li>Les données sociodémographiques proviennent de <b>l’INSEE</b></li>
            <li>Les données immobilières proviennent de la Direction Générale des Finances Publiques (<b>DGFiP</b>) et
                des <b>notaires</b> de France
            </li>
        </ul>
        <p>
            Vos résultats sont prêts, faisons le tour ensemble !
        </p>
    </div>
</ng-template>
<joyrideStep [stepContent]="searchResult2Content"
             joyrideStep="searchResult2Step"
             stepPosition="center">
</joyrideStep>
<ng-template #searchResult2Content>
    <div class="user_onboarding_content">
        <h2>Résultat de recherche</h2>
        <p>
            Voici la liste des annonces correspondant à votre recherche.<br/>
            <br/>
            Votre <b>prochain investissement</b> se trouve sûrement juste ici 😉<br/>
            <br/>
            <b>A savoir</b> : Par défaut, les annonces sont triées par date. Nous avons fait le choix de ne faire
            remonter <b>que les nouveaux biens immobiliers</b>, contrairement aux sites immobiliers classiques.<br/>
            <br/>
            Cela veut dire que si une annonce est supprimée puis repostée, <b>elle n'apparaîtra pas en haut de la
            liste</b> (elle sera plus bas). Sur un site classique, type Leboncoin, cette annonce serait apparue en haut.
        </p>
    </div>
</ng-template>
<ng-template #searchResultFilterContent>
    <div class="user_onboarding_content">
        <h2>Définissez vos critères</h2>
        <p>
            Maintenant, allons choisir ensemble les filtres pour construire votre <b>recherche sur mesure !</b>
        </p>
    </div>
</ng-template>
<ng-template #searchResultContent>
    <div class="user_onboarding_content">
        <h2>Aperçu des annonces</h2>
        <p>
            Pour vous faire gagner un maximum de temps, nous affichons les informations essentielles directement sur
            l'annonce.<br/>
            <br/>
            Il y a 3 catégories d'informations, voyons cela de plus près !<br/>
        </p>
    </div>
</ng-template>
<ng-template #searchResultMainInfoContent>
    <div class="user_onboarding_content">
        <h2>1ère partie : La base</h2>
        <p>
            Vous retrouverez ici les informations de base de l’annonce, ainsi que la <b>liste des sites</b> sur lesquels
            elle est disponible.<br/>
            <br/>
            <b>Astuce</b> : la “Date” correspond à la toute première date de publication de l’annonce (même si l’annonce
            est supprimée puis remise en ligne par l’agence)
        </p>
    </div>
</ng-template>
<ng-template #searchResultInfoContent>
    <div class="user_onboarding_content">
        <h2>2ème partie : Les données avancées</h2>
        <p>
            Sur chaque annonce, nous ajoutons des informations sur le <b>marché local</b>.<br/>
            <br/>
            <b>Astuce</b> : la “Différence” correspond à l’écart de prix au m² entre l’annonce et le marché local.<br/>
            <br/>
            <b>Exemple</b> : Si vous trouvez une annonce à 2.700€/m² dans un ville ou le prix moyen est de 3.000€/m²,
            alors la différence sera de -10%<br/>
        </p>
    </div>
</ng-template>
<ng-template #searchResultKpiContent>
    <div class="user_onboarding_content">
        <h2>3ème partie : Les indicateurs financiers</h2>
        <p>
            Nous avons gardé le meilleur pour la fin !<br/>
            <br/>
            Retrouvez ici le <b>cash-flow</b> et le <b>rendement</b> de cette annonce.<br/>
            <br/>
            <b>Comment les indicateurs sont-ils calculés ?</b><br/>
            <br/>
            LyBox est capable d’analyser le contenu des annonces afin de détecter les charges et d’estimer le loyer de
            l’annonce pour les calculs.
        </p>
    </div>
</ng-template>
<ng-template #searchResultOpenContent>
    <div class="user_onboarding_content">
        <h2>Analyser une annonce</h2>
        <p>
            Si une annonce vous intéresse, vous pouvez <b>l'analyser</b> en cliquant ici.<br/>
            <br/>
            Cliquez sur une annonce et <b>faisons une analyse ensemble</b> !
        </p>
    </div>
</ng-template>
<ng-template #searchSaveContent>
    <div class="user_onboarding_content">
        <h2>Enregistrer votre recherche</h2>
        <p>
            Cliquez ici pour enregistrer votre recherche et y revenir quand vous voulez
        </p>
    </div>
</ng-template>
<ng-template #searchSave2Content>
    <div class="user_onboarding_content">
        <h2>Enregistrer votre recherche</h2>
        <p>
            Cliquez ici pour enregistrer votre recherche et y revenir quand vous voulez
        </p>
    </div>
</ng-template>
<ng-template #searchSaveListContent>
    <div class="user_onboarding_content">
        <h2>Retrouvez vos recherches enregistrées</h2>
        <p>
            Félicitations !<br/>
            <br/>
            Vous pouvez maintenant retrouver toutes vos recherches enregistrées dans ce menu déroulant.
        </p>
    </div>
</ng-template>
<joyrideStep [stepContent]="alertMailStepContent"
             joyrideStep="alertMailStep"
             stepPosition="center">
</joyrideStep>
<ng-template #alertMailStepContent>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/lucky luke.gif" class="user_onboarding_visuel gif"/>
    <div class="p-2 user_onboarding_content">
        <h2>Comment passer devant les autres investisseurs ?</h2>
        <p>
            Votre recherche est claire et bien paramétrée ?<br/>
            <br/>
            Il est maintenant temps de <b>chasser plus vite que votre ombre</b> !<br/>
            <br/>
            Pour cela, nous allons créer des alertes mails pour que vous <b>soyez informé en direct</b>
            lorsqu’une annonce qui vous correspond est publiée <b>sur n’importe quel site internet</b> !
        </p>
    </div>
</ng-template>
<ng-template #alertCreateStepContent>
    <div class="user_onboarding_content">
        <h2>Créer votre alerte mail</h2>
        <p>
            Pour créer votre alerte, cliquez ici
        </p>
    </div>
</ng-template>
